/**
 * @param props
 * @param props.index
 * @param props.chunksCount
 */
export default function isAfterAQuarterOfTheArticleUtil (props) {
  const {
    index,
    chunksCount
  } = props
  return index >= (chunksCount / 4)
}
